import { render, staticRenderFns } from "./topicGoodsModal.vue?vue&type=template&id=6d5fb738&scoped=true"
import script from "./topicGoodsModal.vue?vue&type=script&lang=js"
export * from "./topicGoodsModal.vue?vue&type=script&lang=js"
import style0 from "./topicGoodsModal.vue?vue&type=style&index=0&id=6d5fb738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5fb738",
  null
  
)

export default component.exports